var checkHasWriteJob = function (requiredJobs) {
    return requiredJobs.some(function (j) { return j === 'direct_deposit_payment' || j === 'direct_deposit_switch'; });
};
export default checkHasWriteJob;
